<template>
  <b-modal
    :id="modalId"
    ref="modal"
    centered
    :title="title || '사본 만들기'"
    :busy="loading"
    no-close-on-backdrop
    no-close-on-esc
    @hidden="onHidden"
  >
    <p class="mb-2 f-95">
      <span v-if="sourceTitle">
        <span class="fw-600">{{ sourceTitle }}</span
        >의 사본을 만듭니다.
      </span>
      <span v-else>새 사본을 만듭니다.</span>
    </p>
    <p class="mb-3 f-90 gray-600">
      내용은 그대로 두고, 별도 항목으로 새로 만듭니다. 새 사본을 수정해도 원본은 바뀌지 않습니다.
    </p>
    <b-form-group label="새 제목" label-class="fw-500">
      <b-form-input
        v-model="newTitle"
        :placeholder="placeholder || '사본의 제목을 입력하세요'"
        :state="errorMessage ? false : null"
        :disabled="loading"
        autofocus
        @keyup.enter="handleConfirm"
      />
      <b-form-invalid-feedback :state="errorMessage ? false : null">
        {{ errorMessage }}
      </b-form-invalid-feedback>
    </b-form-group>

    <template #modal-footer="{ cancel }">
      <b-button :disabled="loading" @click="cancel()">취소</b-button>
      <b-button variant="teal" :disabled="loading" @click="handleConfirm">
        <b-spinner v-if="loading" small class="mr-2" />
        사본 만들기
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'DuplicateItemModal',
  props: {
    modalId: { type: String, default: 'duplicate-item-modal' },
    sourceTitle: { type: String, default: '' },
    title: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    // 동기 검증 함수: (title) => string | null. null이면 유효
    validator: { type: Function, default: null }
  },
  data() {
    return {
      newTitle: '',
      loading: false,
      errorMessage: ''
    };
  },
  methods: {
    // show(defaultTitle): 호출자가 다음 번호 등 기본 제목을 직접 계산해 넘긴다.
    show(defaultTitle) {
      this.newTitle = defaultTitle || '';
      this.errorMessage = '';
      this.loading = false;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    setLoading(value) {
      this.loading = !!value;
    },
    handleConfirm() {
      const trimmed = (this.newTitle || '').trim();
      if (!trimmed) {
        this.errorMessage = '제목을 입력해 주세요.';
        return;
      }
      if (typeof this.validator === 'function') {
        const msg = this.validator(trimmed);
        if (msg) {
          this.errorMessage = msg;
          return;
        }
      }
      this.errorMessage = '';
      this.$emit('confirm', trimmed);
    },
    onHidden() {
      this.newTitle = '';
      this.errorMessage = '';
      this.loading = false;
      this.$emit('hidden');
    }
  }
};
</script>
